import { defineComponent } from "vue";
import { mapMutations, mapGetters } from "vuex";

export const AbilityMixin = defineComponent({
  data: () => ({
    abilityMixin: {
      canAccess(...abilities) {
        for (const ability of abilities) { 
          if (this.abilities.includes(ability)) return true
        }

        return false
      },
      abilities: [],
    }, 
  }), 
  
  computed: {
    ...mapGetters(["getCurrentSession"])
  },

  methods: {
    ...mapMutations(['loadSession']),
  },

  created() {
    this.loadSession()

    const { abilities } = this.getCurrentSession

    this.abilityMixin.abilities = abilities
  },

  watch: {
    'getCurrentSession': {
      handler({ abilities }) {
        this.abilityMixin.abilities = abilities
      },
      deep: true
    }
  }
});
